import { get } from 'lodash'
import { formatCentsToDollars } from 'utils/price'

export const mapServiceDetails = (serviceDetails, activeMarkerDetails) => {
  if (!serviceDetails) return activeMarkerDetails

  return {
    ...activeMarkerDetails,
    servicePrice: formatCentsToDollars(get(serviceDetails, 'servicePriceCents')),
    pricingPeriodInterval: get(serviceDetails, 'pricingPeriod.periodInterval'),
    pricingPeriodPer: get(serviceDetails, 'pricingPeriod.periodPer'),
    quantity: get(serviceDetails, 'quantity'),
    measureUnit: get(serviceDetails, 'measure.unit'),
    measureVolume: get(serviceDetails, 'measure.volume'),
    methodType: get(serviceDetails, 'methodType') ?? get(serviceDetails, 'method'),
  }
}
